// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolFactory } from "./DataCacheToolFactory.js";
import { CustomEvent } from "../../Utils/CustomEvents.js";
import { ErrorInformationStorage } from "../ErrorInformationStorage.js";
import { DynProperty } from "../DynProperty.js";

export let _ToolsCache = function ()
{
    this.OnAddTool = new CustomEvent();
    this.OnRemoveTool = new CustomEvent();
    this.OnChangeTool = new CustomEvent();
    this.Tools = [];
};

_ToolsCache.prototype.AddTool = function (tool)
{
    tool.OnUpdate.Subscribe(this.UpdateTool, this);
    this.Tools.push(tool);
    this.OnAddTool.Raise(tool);
};
_ToolsCache.prototype.RemoveTool = function (tool)
{
    tool.OnUpdate.UnSubscribe(this.UpdateTool, this);
    var remIndex = this.Tools.indexOf(tool);
    this.Tools.splice(remIndex, 1);

    this.OnRemoveTool.Raise(tool);
    // delete tool;
};
_ToolsCache.prototype.UpdateTool = function (tool)
{
    this.OnChangeTool.Raise(tool);
};

_ToolsCache.prototype.CheckToolEnabilityAndUpdateInstrument = function (tool, ins)
{
    if (tool.AssignedSymbol === ins.GetInteriorID())
    {
        //Non fixed list instrument case
        tool.Instrument = ins;
        return true;
    }
    return false;
}

_ToolsCache.prototype.GetTools = function (ins)
{
    var res = [];

    if (ins == null)
        return res;

    for (var i = 0; i < this.Tools.length; i++)
    {
        var tool = this.Tools[i];
        if (this.CheckToolEnabilityAndUpdateInstrument(tool, ins))
            res.push(tool);
    }

    return res;
}

_ToolsCache.prototype.GetToolById = function (toolId)
{
    var res = null;

    if (!toolId)
        return res;

    for (var i = 0; i < this.Tools.length; i++)
    {
        var tool = this.Tools[i];
        if (tool.ID === toolId)
            return tool;
    }
    return res;
};

_ToolsCache.prototype.Clear = function ()
{
    this.Tools.length = 0;
}

_ToolsCache.prototype.GetToolsForSave = function ()
{
    let result = [];
    for (let i = 0; i < this.Tools.length; i++)
    {
        let tool = this.Tools[i];

        let props = DynProperty.serialize(tool.Properties());
        let type = tool.ToolType;
        result.push({ type: type, properties: props });
    }
    return JSON.stringify(result);
}

_ToolsCache.prototype.CreateToolsFromSaves = function (properies, dataCache)
{
    if (!properies)
        return;
    this.Clear();
    let tools = [];
    try
    {
        tools = JSON.parse(properies)
    }
    catch (e)
    {
        ErrorInformationStorage.GetException(e);
        tools = [];
    }
    for (let i = 0; i < tools.length; i++)
    {
        let tool = tools[i];
        let newTool = DataCacheToolFactory.Create(tool.type, dataCache);
        newTool.callBack(DynProperty.deserialize(tool.properties));
        this.Tools.push(newTool);
    }
}

_ToolsCache.Action =
{
    Add: 0,
    Remove: 1,
    Update: 2,
    Synhronize: 3
}

export let ToolsCache = new _ToolsCache();

